var base = require('settings/invoices/invoice-list');

Vue.component('spark-invoice-list', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/invoices/invoice-list.js